import { Injectable } from '@angular/core';

// // import {Serial} from '@ionic-native/serial/ngx';
// import {from, Observable, of, TimeoutError} from 'rxjs';
// import {HttpEvent, HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
// import {AlertController, Platform} from '@ionic/angular';
// import {CurrentSettings, State, StateInterface} from '../interfaces/biozoom-api/app-configuration';
// import {SerialDispatcher} from '../methods/serial-dispatcher';
// import {ScannerStatus} from '../interfaces/scanner-api/scanner-status';
// import {catchError, delay, repeat, switchMap, timeout} from 'rxjs/operators';
interface FileSaver extends EventTarget {
  readyState: number;
  onwritestart: (event: ProgressEvent) => void;
  onwriteend: (event: ProgressEvent) => void;
  onprogress: (event: ProgressEvent) => void;
  onwrite: (event: ProgressEvent) => void;
  onabort: (event: ProgressEvent) => void;
  onerror: (event: ProgressEvent) => void;
  error: Error;
  abort(): void;
}

interface FileError {
  code: number;
}

interface FileWriter extends FileSaver {
  position: number;
  length: number;
  write(data: Blob | string | ArrayBuffer): void;
  seek(offset: number): void;
  truncate(size: number): void;
}

interface FileSystem extends FileSystemEntry {
  createWriter(successCallback: (writer: FileWriter) => void, errorCallback?: (error: FileError) => void): void;
  file(successCallback: (file: File) => void, errorCallback?: (error: FileError) => void): void;
  remove(successCallback: () => void, errorCallback?: (error: FileError) => void): void;
}

@Injectable({
  providedIn: 'root'
})
export class FileManagerUtils {

  private result = '';
  private ready = false;

  awaitResult = async (): Promise<boolean> => {
    let timer = 0;
    while (!this.ready) {
      if (timer > 5000) {
        return false;
      }
      timer += 5;
      await new Promise((resolve, reject) => setTimeout(resolve, 5));
    }
    return true;
  }

  getFile = async (fileName: string): Promise<FileSystem> => {
    let fe: FileSystem = null;
    this.ready = false;
    // @ts-ignore
    window.requestFileSystem(1, 0, fs => {

      fs.root.getFile(fileName, { create: true, exclusive: false }, (fileEntry: FileSystem) => {
        console.log(`Successfully opened/created file: ${fileName}`);
        fe = fileEntry;
        this.ready = true;
        // return fileEntry;
      }, (e) => { console.log(`Count not open file: ${fileName}`); this.ready = true; });
    }, (e) => { console.log(`Count not open file: ${fileName}`); this.ready = true; });
    // return fe;
    await this.awaitResult();
    return fe;
  }

  readFile = async (fileEntry: FileSystem): Promise<string> => {
    this.result = '';
    this.ready = false;

    fileEntry.file((file) => {
      const reader = new FileReader();
      reader.onloadend = (a) => {
        const result = a.target.result;
        if (typeof result === 'string') {
          this.result = result;
        }
        this.ready = true;
        console.log(`File read successfully.`);
      };
      if (file.size === 0) {
        this.result = '';
        this.ready = true;
      } else {
        reader.readAsText(file);
      }


    }, () => { this.ready = true; });

    await this.awaitResult();
    return this.result;
  }

  writeFile = async (file: FileSystem, data: string, append: boolean = false): Promise<boolean> => {
    this.ready = false;
    let didWrite = false;
    file.createWriter((fileWriter) => {

      fileWriter.onwriteend = () => {
        console.log('Successful wrote file.');
        this.ready = true;
        didWrite = true;
      };

      fileWriter.onerror = (e) => {
        console.log('Failed file write: ' + e.toString());
        this.ready = true;
        didWrite = false;
      };

      const dataObj = new Blob([data], { type: 'text/plain' });

      if (append && fileWriter.length > 0) {
        try {
          fileWriter.seek(fileWriter.length);
        }
        catch (e) {
          didWrite = false;
        }
      }
      fileWriter.write(dataObj);
    });
    await this.awaitResult();
    return didWrite;
  }

  deleteFile = async (file: FileSystem) => {
    this.ready = false;
    file.remove(
      () => { console.log(`File deleted successfully.`); this.ready = true; },
      () => { console.log(`Could not delete file.`); this.ready = true; }
    );
    await this.awaitResult();
  }

  getIndex = (data: string) => {
    const indices = data.split(',');
    if (data.length === 0) {
      return -1;
    }
    return Number(indices[0]);
  }

  appendIndex = (data: string): [number, string, number] => {
    const indices = data.split(',');
    if (data.length === 0) {
      return [0, '0', 0];
    }
    let newIndex: string;
    if (isNaN(Number(indices[indices.length - 1]))) {
      newIndex = '0';
    } else {
      newIndex = String(Number(indices[indices.length - 1]) + 1);
    }
    indices.push(newIndex);
    return [Number(newIndex), indices.join(','), indices.length];
  }

  popIndex = (data: string): [string, number] => {
    let indices = data.split(',');
    if (data.length === 0) {
      return ['', 0];
    }
    indices = indices.slice(1);
    return [indices.join(','), indices.length];
  }


  deleteFileGeneric = (fileName: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      const dirPath = window.cordova.file.externalDataDirectory;

      const handleError = (error) => {
        console.error('Error: ' + error.code + ' - ' + error.message);
        reject(error);
      };

      // @ts-ignore
      window.resolveLocalFileSystemURL(dirPath, (dirEntry) => {
        // @ts-ignore
        dirEntry.getFile(fileName, { create: false }, (fileEntry) => {
          fileEntry.remove(
            () => {
              console.log('File deleted:', fileName);
              resolve();
            },
            handleError
          );
        }, handleError);
      }, handleError);
    });
  }


  listFilesGeneric = (): Promise<string[]> => {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      const dirPath = window.cordova.file.externalDataDirectory;

      const handleError = (error) => {
        console.error('Error: ' + error.code + ' - ' + error.message);
        reject(error);
      };
      // @ts-ignore
      window.resolveLocalFileSystemURL(dirPath, (dirEntry) => {
        // @ts-ignore
        const reader = dirEntry.createReader();
        reader.readEntries((entries) => {
          const files = entries
            .filter(entry => entry.isFile)
            .map(entry => entry.name);
          resolve(files);
        }, handleError);
      }, handleError);
    });
  }


  readFileGeneric = (fileName: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      const dirPath = window.cordova.file.externalDataDirectory;

      const handleError = (error) => {
        console.error('Error: ' + error.code + ' - ' + error.message);
        resolve(undefined);
        // reject(error);
      };

      // @ts-ignore
      window.resolveLocalFileSystemURL(dirPath, (dirEntry) => {
        // @ts-ignore
        dirEntry.getFile(fileName, { create: false }, (fileEntry) => {
          fileEntry.file((file) => {
            const reader = new FileReader();

            reader.onloadend = () => {
              resolve(reader.result as string);
            };

            reader.onerror = (error) => {
              console.error('File read failed: ' + error.toString());
              reject(error);
            };

            reader.readAsText(file);
          }, handleError);
        }, handleError);
      }, handleError);
    });
  }


  writeFileGeneric = (data: string, fileName: string) => {
    // @ts-ignore
    const dirPath = window.cordova.file.externalDataDirectory;
    const handleError = (error) => {
      console.error('Error: ' + error.code + ' - ' + error.message);
    };

    // @ts-ignore
    window.resolveLocalFileSystemURL(dirPath, (dirEntry) => {
      // @ts-ignore
      dirEntry.getFile(fileName, { create: true, exclusive: false }, (fileEntry) => {
        fileEntry.createWriter((fileWriter) => {
          fileWriter.onwriteend = () => {
            console.log('File write successful');
          };

          fileWriter.onerror = (error) => {
            console.error('File write failed: ' + error.toString());
          };

          const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
          fileWriter.write(blob);
        }, handleError);
      }, handleError);
    }, handleError);
  }
}
